(function($, undefined) {
    'use strict';

    var autoScrollUp = function() {
        //Half duration since elements were cloned in the init to create seamless scrolling
        var speed = 500 * $(".rollup-membership-banner-item-single-ctn", $(this)).length;
        $(this).css({top: 0}).animate({top: -($(this).outerHeight() * 0.5) - 7.5}, speed, "linear", autoScrollUp);
    };

    var initRollupBannerSCroll = function() {
        $('.rollup-membership-banner-scroll-ctn').each(function() {
            var speed = 1000 * $(".rollup-membership-banner-item-single-ctn", $(this)).length;
            $(".rollup-membership-banner-scroll-inner-ctn", $(this)).html($(".rollup-membership-banner-scroll-inner-ctn", $(this)).html() + $(".rollup-membership-banner-scroll-inner-ctn", $(this)).html());
            $(".rollup-membership-banner-scroll-inner-ctn", $(this)).css({top: 0}).animate({top: -($(".rollup-membership-banner-scroll-inner-ctn", $(this)).outerHeight() * 0.5) - 7.5}, speed, "linear", autoScrollUp);
        });
    };

    var showMoreRows = function(e) {
        const t = $(e.currentTarget);
        const ctn = t.closest('tbody');
        
        $('tr.hide', ctn).removeClass('hide');
        t.closest('tr').addClass('hide');
    };
    
    var changePageTable = function(e) {
        e.preventDefault();
        const a = $(e.currentTarget);
        if (a.hasClass('processing')) {
            return false;
        }
        a.addClass('processing');
        
        const ctn = a.closest('.table-inner-wrap');
        let dataset = ctn.data();
        let page = dataset.page || 1;
        
        if (a.hasClass('next-page')) {
            page++;
        } else {
            page--;
        }
        $.ajax({
            method: "post",
            url: '/action/pmiMemberRecognition',
            data: {
                category: dataset.category,
                pmrJoinDate: dataset.joinDate,
                pmrPage: page
            },
            cache: false,
            success: (resp) => {
                const parentEl = resp.children[0];
                const accountList = parentEl.getElementsByTagName('PMIAccount');
                const pagerEl = parentEl.getElementsByTagName('Pager')[0];
                const navCtn = a.closest('.pager-numbers-and-arrows-ctn');
                let content = '';
                
                for (let el of accountList) {
                    let name = el.hasAttribute('fullName') ? el.getAttribute('fullName') : el.getAttribute('firstName') + ' ' + el.getAttribute('lastName');
                    let date = el.getAttribute('joinDate') || '';
                    
                    if (dataset.category === 'certifications') {
                        date = el.getAttribute('pmpDate') || '';
                    }
                    if (date && dataset.usDate) {
                        let m = date.substring(3, 5);
                        let d = date.substring(0, 2);
                        
                        date = m + date.substring(2, 3) + d + date.substring(5);
                    }
                    
                    content += `<tr role="row"><td class="" data-th="">${name}</td><td class="" data-th="">${date}</td>`;
                    if (dataset.category === 'certifications') {
                        content += `<td class="" data-th="">${el.getAttribute('designation')}</td>`;
                    }
                    content += '</tr>';
                }
                ctn.find('tbody').html(content);
                
                ctn.data('page', page);
                navCtn.find('.pager-numbers-ctn .current').text(page);
                if (a.hasClass('next-page')) {
                    navCtn.find('.previous-page').show();
                    if (page == pagerEl.getAttribute('pages')) {
                        a.hide();
                    }
                } else {
                    navCtn.find('.next-page').show();
                    if (page === 1) {
                        a.hide();
                    }
                }
                a.removeClass('processing');
            }
        });
    };

    var init = function() {
        if ($('.rollup-membership-banner-com-ctn').hasClass('ver1')) {
            initRollupBannerSCroll();
        }
        $('.rollup-membership-banner-certifications-show-more').on('click', showMoreRows);
        $('.next-page, .previous-page', $('.member-recognition-pager')).on('click', changePageTable);
    };

    $(window).ready(init);

})(jQuery);

